import React, { Component } from 'react'
import PropTypes from 'prop-types'
import hideElementHoc from './HideElement'
import { Flex } from 'reflexbox'
import ProgressBar from 'components/fulcrum/progressBar/FulcrumCircularProgressBar'

export default (filters) => {
  const AsyncHideComponent = hideElementHoc(filters)

  return class AsyncProgressBar extends Component {
    render() {
      return (
        <AsyncHideComponent>
          <Flex
            justify='center'
            align='center'
          >
            <ProgressBar/>
          </Flex>
        </AsyncHideComponent>
      )
    }
  }
}
